





















































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentRecebimentoReport extends Vue {
  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get fontePagadoras() { return this.getRecebimentoStore.fontePagadoras }
  get fontePagadora() { return this.getRecebimentoStore.fontePagadora }
  set fontePagadora(value) { this.getRecebimentoStore.setFontePagadora(value) }

  get relatorios() { return this.getRecebimentoStore.relatorios }
  get relatorio() { return this.getRecebimentoStore.relatorio }
  set relatorio(value) { this.getRecebimentoStore.setRelatorio(value) }

  get anoMesReferencia() { return this.getRecebimentoStore.anoMesReferencia }
  set anoMesReferencia(value) { this.getRecebimentoStore.setAnoMesReferencia(value) }

  loadGerarRelatorio: boolean = false
  get loadingGerarRelatorio() { return this.loadGerarRelatorio }
  set loadingGerarRelatorio(value: boolean) { this.loadGerarRelatorio = value }

  get datas() {
    return Array.from([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], (n: number) => moment().subtract(n, 'month').format('YYYY-MM-01'))
  }

  formatMonthAndYear(value) {
    return (moment(value).format('MMM / YYYY')).toLocaleUpperCase()
  }

  formatFontePagadoraItems() {
    return this.fontePagadoras.map((item) => {
      if (item.fontePagadoraId && item.fontePagadoraNome) {
        return item
      }

      return {
        fontePagadoraId: item.id,
        fontePagadoraNome: item.nome,
      }
    })
  }


  async generateRelatorioByFontePagadora() {
    if (!this.relatorio || !this.relatorio.id || !this.relatorio.nome) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo tipo relatório é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    this.loadingGerarRelatorio = true
    const request = await this.getRecebimentoStore.generateRelatorioByFontePagadora()
    if (!request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
      this.loadingGerarRelatorio = false
      return
    }

    this.openExcel(this.getRecebimentoStore.relatorioEmitido)

    this.loadingGerarRelatorio = false
  }


  async openExcel(params: any) {
    const link = document.createElement('a')
    link.href = params.file
    link.download = decodeURIComponent(params.fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
